import { defineComponent, createBlock, openBlock, unref, mergeProps, withCtx, renderSlot } from "vue";
import { cn } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
import { dialogVariants } from "../../dialog/styles/index.js";
import { _ as _sfc_main$1 } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/AlertDialog/AlertDialogTitle.js";
import { reactiveOmit } from "../../../../node_modules/.pnpm/@vueuse_shared@13.3.0_vue@3.5.16_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AlertDialogTitle",
  props: {
    class: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(__props) {
    const props = __props, delegatedProps = reactiveOmit(props, ["class"]), dialogClasses = dialogVariants();
    return (_ctx, _cache) => (openBlock(), createBlock(unref(_sfc_main$1), mergeProps({
      class: unref(cn)(unref(dialogClasses).header(), props.class),
      "data-slot": "alert-dialog-title"
    }, unref(delegatedProps)), {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=AlertDialogTitle.js.map
